import { useCallback } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import { Button, CircularLoader, EmptyState } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

const QueryStatesErrorSvgImage = () => {
    return <SWReactIcons iconName="empty-state-browser" />;
};

export type QueryStatesProps = {
    isLoading: boolean;
    isError: boolean;
    onRetry: () => void;
    loadingDataAutomation?: string;
    errorDataAutomation?: string;
    errorRetryDataAutomation?: string;
};

export const QueryStates = ({
    isLoading,
    isError,
    onRetry,
    loadingDataAutomation = "query-states-loading",
    errorDataAutomation = "query-states-error",
    errorRetryDataAutomation = "query-states-error-retry",
}: QueryStatesProps) => {
    const { translate } = useTranslate();

    const renderErrorCta = useCallback(() => {
        return (
            <Button
                onClick={onRetry}
                data-automation={errorRetryDataAutomation}
            >
                {translate("si.common.refresh")}
            </Button>
        );
    }, [errorRetryDataAutomation, onRetry, translate]);

    if (isLoading) {
        return (
            <Flex
                flex="1"
                justifyContent="center"
                alignItems="center"
                width="100%"
                data-automation={loadingDataAutomation}
            >
                <CircularLoader isLarge />
            </Flex>
        );
    }

    if (isError) {
        return (
            <Flex
                flex="1"
                justifyContent="center"
                width="100%"
                data-automation={errorDataAutomation}
            >
                <EmptyState
                    title={translate("common.error")}
                    SvgImage={QueryStatesErrorSvgImage}
                    CtaButtons={renderErrorCta}
                    subtitle={translate("si.common.error.reload")}
                />
            </Flex>
        );
    }

    return null;
};
